import { createBrowserRouter } from "react-router-dom";
import Home from "./Screens/Home/Home";
import RegisterAndLogin from "./Components/RegisterAndLogin/RegisterAndLogin";
import Layout from "./Layout";
import MakeUpMainScreen from "./Screens/MakeUpMainScreen/MakeUpMainScreen";
import Hair from "./Components/Hair/Hair";
import Blush from "./Components/Blush/Blush";
import Lipstick from "./Components/Lipstick/lipstick";
import Eyeliner from "./Components/Eyeliner/Eyeliner";
import Eyeshadow from "./Components/Eyeshadow/Eyeshadow";
import CaptureImage from "./Components/CaptureImage/Captureimage";
import UploadImages from "./Components/UploadImages/UploadImages";
import ComingSoon from "./Screens/Fallback/ComingSoon"; // Import fallback page

// const AccessToken = "x7yxf84yh3y88chc895ghf89c9iz7xy56ab2cd3ef4gh5ij6kl7mn8op9qr0st1uv23aB7x7yxf84yh3y88chc895ghf89c9iz7xy56ab2cd3ef4gh5ij6kl7mn8op9qr0st1uv23aB7x7yxf84yh3y88chc895ghf89c9iz7xy56ab2cd3ef4gh5ij6kl7mn8op9qr0st1uv23aB7x7yxf84yh3y88chc895ghf89c9iz7xy56ab2cd3ef4gh5ij6kl7mn8op9qr0st1uv23aB7";
const AccessToken = process.env.REACT_APP_TOKEN;
localStorage.setItem("AccessToken", AccessToken);

const router = createBrowserRouter([
  {
    path: `/${AccessToken}`,
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "signup", element: <RegisterAndLogin /> },
      { path: "login", element: <RegisterAndLogin /> },
      { path: "menus", element: <MakeUpMainScreen /> },
      { path: "capture", element: <CaptureImage /> },
      { path: "hair", element: <Hair /> },
      { path: "blush", element: <Blush /> },
      { path: "lipstick", element: <Lipstick /> },
      { path: "eyeliner", element: <Eyeliner /> },
      { path: "eyeshadow", element: <Eyeshadow /> },
      { path: "recommend", element: <UploadImages /> },
    ],
  },
  { path: "*", element: <ComingSoon /> }, 
]);

export default router;
